module.exports = __webpack_public_path__ + "img/ban4.8164db1d.jpg";